import { formatApplicantIdSegment } from './applicantIdFormat'
import type { ResidentRow } from '../types'

export function residentDetailPath(r: ResidentRow): string | null {
  if (r.applicant_id == null) return null
  const raw = r.fk_user_id
  if (raw == null || raw === "") return null
  const n = Number(raw)
  if (!Number.isFinite(n) || n <= 0) return null
  const applicantId = formatApplicantIdSegment(r.applicant_id)
  return `/resident/resident-detail/${applicantId}/${n}`
}

/** React `/application/:applicantId` — Angular pending apps `routerLink="/application/{{applicant_id}}"`. */
export function applicationDetailPath(r: ResidentRow): string | null {
  if (r.applicant_id == null) return null
  return `/application/${formatApplicantIdSegment(r.applicant_id)}`
}
